import { FeatureLink } from "@softmax/web-features/navigation";

import { buildHref, matchRoute } from "@softmax/web-addresses";

import { leavesTheSite } from "@softmax/web-features/site/records";

import type { PillMenuData } from "../use-pill-menu";

import type { SiteHeaderControls } from "../use-site-header";

import { isNavigationClick } from "../link-click";

import joinedStyles from "../account-pill.module.css";

import { type MenuLink, Item } from "../pill-menu-items";

export function HeaderLeagueNavigation({
  data,
  member,
  onNavigate,
}: {
  readonly data: Pick<
    PillMenuData,
    "coworld" | "currentLeagues" | "directory" | "pathname"
  >;
  readonly member: boolean;
  readonly onNavigate: SiteHeaderControls["onNavigate"];
}) {
  const coworld = data.coworld;

  if (coworld === null) return null;

  const route = matchRoute(data.pathname);
  // A game's own address stands for its default league, or the league named after it.
  const leagueLinks: MenuLink[] = data.currentLeagues.map((entry) => ({
    label: entry.name,
    href: buildHref({ name: "game.play", ...entry.route }),
    current:
      route.area === "game" &&
      (route.league
        ? entry.route.league === route.league
        : entry.route.league === route.gameSlug ||
          entry.league_id === entry.default_league_id),
  }));
  const policies = { label: "Policies", href: buildHref({ name: "policies" }) };
  return (
    <nav
      aria-label={`${coworld.name} leagues`}
      className={joinedStyles.leagueBar}
      data-league-bar=""
    >
      <FeatureLink
        href={coworld.href}
        className={joinedStyles.game}
        onClick={(event) => {
          if (isNavigationClick(event)) onNavigate(coworld.href);
        }}
      >
        {coworld.icon && (
          <img className={joinedStyles.gameIcon} src={coworld.icon} alt="" />
        )}
        <span className={joinedStyles.gameName}>{coworld.name}</span>
      </FeatureLink>
      <span className={joinedStyles.chevron} aria-hidden="true">
        ›
      </span>
      <ul className={joinedStyles.leagues}>
        {leagueLinks.map((link) => (
          <Item
            key={link.href}
            link={link}
            styles={joinedStyles}
            onNavigate={onNavigate}
          />
        ))}
        {data.directory.isPending && (
          <li className={joinedStyles.leagueNote}>
            <output>Loading leagues…</output>
          </li>
        )}
        {data.directory.isError && (
          <li className={joinedStyles.leagueNote}>
            <output>Could not load leagues.</output>{" "}
            <button
              type="button"
              className={joinedStyles.leagueRetry}
              onClick={() => void data.directory.refetch()}
            >
              Retry leagues
            </button>
          </li>
        )}
      </ul>
      <ul className={joinedStyles.leagueEnd}>
        {coworld.items
          .filter((item) => item.key === "docs" && leavesTheSite(item.href))
          .map((item) => (
            <Item
              key={item.href}
              link={item}
              styles={joinedStyles}
              onNavigate={onNavigate}
            />
          ))}
        {member && (
          <Item
            link={{ label: "My policies", href: policies.href }}
            styles={joinedStyles}
            onNavigate={onNavigate}
          />
        )}
      </ul>
    </nav>
  );
}
